// from https://stackoverflow.com/questions/10473745/compare-strings-javascript-return-of-likely
const editDistance = (s1: string, s2: string) => {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  const costs = [];
  for (let i = 0; i <= s1.length; i++) {
    let lastValue = i;
    for (let j = 0; j <= s2.length; j++) {
      if (i === 0) costs[j] = j;
      else {
        if (j > 0) {
          let newValue = costs[j - 1];
          if (s1.charAt(i - 1) !== s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }
  return costs[s2.length];
};

const getSimilarity = (s1: string, s2: string) => {
  let longer = s1;
  let shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  const longerLength = longer.length;
  if (longerLength === 0) {
    return 1.0;
  }
  return (longerLength - editDistance(longer, shorter)) / longerLength;
};

/**
 * returns string in `arr` closest to `str` or `""` if `arr` is empty
 */
export const getSimilar = (str: string, arr: string[]) => {
  if (!arr.length) return "";

  let curMaxSimilarStr = arr[0];
  let curMaxSimilarity = getSimilarity(str, arr[0]);

  for (const s of arr) {
    const similarity = getSimilarity(str, s);
    if (similarity > curMaxSimilarity) {
      curMaxSimilarStr = s;
      curMaxSimilarity = similarity;
    }
  }
  return curMaxSimilarStr;
};

export const getPathname = () =>
  window.location.pathname.replace(/(\/+$)|(^\/+)/gm, "");
